/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { CampaignBuyerEditPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/campaign-targets/$id')({
  component: CampaignBuyerEditRoute,
  beforeLoad: requireRole(['admin']),
})

function CampaignBuyerEditRoute() {
  const { id } = Route.useParams()
  return <CampaignBuyerEditPage campaignBuyerId={id} />
}
